import { render } from "./EmailConfirmation.vue?vue&type=template&id=ef0820d4&scoped=true"
import script from "./EmailConfirmation.vue?vue&type=script&lang=js"
export * from "./EmailConfirmation.vue?vue&type=script&lang=js"

import "./EmailConfirmation.vue?vue&type=style&index=0&id=ef0820d4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef0820d4"]])

export default __exports__